/**
 * Service for normalizing form-related fields
 */

/**
 * Forces form input to adhere to IPV4 / cidr construction standards
 *
 * @param {string} value - value to coerce
 * @returns {string} - returns new value
 */
export function normalizeCidr(value) {
  return value.replace(/[^0-9./]/, '');
}

export default {
  normalizeCidr,
};
